var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 8,
    viewBox: "0 0 92 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.813 4.35356C92.0083 4.1583 92.0083 3.84171 91.813 3.64645L88.631 0.46447C88.4358 0.269208 88.1192 0.269208 87.9239 0.46447C87.7287 0.659732 87.7287 0.976315 87.9239 1.17158L90.7524 4L87.9239 6.82843C87.7287 7.02369 87.7287 7.34028 87.9239 7.53554C88.1192 7.7308 88.4358 7.7308 88.631 7.53554L91.813 4.35356ZM-8.88404e-08 4.5L91.4595 4.5L91.4595 3.5L8.88404e-08 3.5L-8.88404e-08 4.5Z",
    fill: "#303E3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/LongArrow.aad371c69ff726f3d46b71ff0ce0ebf8.svg";
export { ForwardRef as ReactComponent };